import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set document title and meta tags for CHAMALEON branding
document.title = 'CHAMALEON — Premium Coatings & Auto Chemistry';
// Helper to set or create a meta tag
function setMeta(attr: string, value: string, content: string) {
  let el = document.querySelector(`meta[${attr}="${value}"]`) as HTMLMetaElement | null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
// Standard meta
setMeta('name', 'description', 'CHAMALEON — Premium coatings and auto chemistry brand. 60+ years of excellence, present in 80 countries.');
setMeta('name', 'author', 'CHAMALEON');
// Open Graph (Facebook, Telegram, WhatsApp, etc.)
setMeta('property', 'og:title', 'CHAMALEON — Premium Coatings & Auto Chemistry');
setMeta('property', 'og:description', 'Professional solutions for distribution, retail, and body shops. 60+ years of excellence in 80 countries.');
setMeta('property', 'og:site_name', 'CHAMALEON');
setMeta('property', 'og:type', 'website');
setMeta('property', 'og:image', 'https://cdn.magicpatterns.com/uploads/dPC9v62jFFRaqiBcJdHaJe/chamaeleon_logo_white-yellow_RGB_копія.png');
// Twitter Card
setMeta('name', 'twitter:card', 'summary_large_image');
setMeta('name', 'twitter:title', 'CHAMALEON — Premium Coatings & Auto Chemistry');
setMeta('name', 'twitter:description', 'Professional solutions for distribution, retail, and body shops. 60+ years of excellence in 80 countries.');
setMeta('name', 'twitter:image', 'https://cdn.magicpatterns.com/uploads/dPC9v62jFFRaqiBcJdHaJe/chamaeleon_logo_white-yellow_RGB_копія.png');
render(<App data-id="element-321" />, document.getElementById('root'));